import i18n from "../../../i18n.js";
import moment from "moment";

const TimePeriods = {
    last_1_hour: {
        value: "last_1_hour",
        label: i18n.t("last_hour", { count: 1 }),
        start: () => moment().subtract(59, "m").startOf("m"),
        end: () => moment().startOf("m"),
    },
    last_24_hour: {
        value: "last_24_hour",
        label: i18n.t("last_hour", { count: 24 }),
        start: () => moment().subtract(23, "h").startOf("h"),
        end: () => moment().endOf("h"),
    },
    last_7_day: {
        value: "last_7_day",
        label: i18n.t("last_day", { count: 7 }),
        start: () => moment().subtract(6, "d").startOf("d"),
        end: () => moment().endOf("d"),
    },
    last_30_day: {
        value: "last_30_day",
        label: i18n.t("last_day", { count: 30 }),
        start: () => moment().subtract(29, "d").startOf("d"),
        end: () => moment().endOf("d"),
    },
} as const;

type CustomPeriod = {
  value: "custom" | "all_time",
  label: string,
  start: () => moment.Moment,
  end: () => moment.Moment,
}

export const defaultPeriod: keyof typeof TimePeriods = "last_24_hour";
export type Period = typeof TimePeriods[keyof typeof TimePeriods] | CustomPeriod;
export default TimePeriods;
